import { useState } from "react";
import { useTranslation } from "react-i18next";
import ToastConstant from "@configs/react-toastify/snackbar";
import { TOAST } from "@constants/index";
import queryKeys from "../configs/react-query/query-key";
import { normalizeResponseData } from "../utils/common";
import { useMutationData } from "./useMutationData";
import useSuccessToast from "@configs/react-toastify/snackbar";

export const useFileGroupAPI = (fileGroupNo, page = 1, pageSize = 5 ) => {
  const [fileInfo, setFileInfo] = useState([]);
  const [documentTotalData, setDocumentTotalData] = useState(0);
  const { t } = useTranslation();

  const getFileInformationPagination = useMutationData(
    () => {
      const startRow = (page - 1) * pageSize;
      const url = `${queryKeys.getFileInfo}?fileGroupNo=${fileGroupNo}&pageSize=${pageSize}&startRow=${startRow}`;
      return url;
    },
    {
      method: "GET",
    },
    {
      onSuccess: (response) => {
        if (typeof response !== "string") {
          setFileInfo(normalizeResponseData(response.object));
          setDocumentTotalData(response.objectCount || response.object.length);
        }
      },
      onError: (error) => {
        console.error("Error during get data:", error);
      },
    },
  );

  const getFileInformation = useMutationData(
    `${queryKeys.getFileInfo}/${fileGroupNo}`,
    {
      method: "GET",
    },
    {
      onSuccess: (response) => {
        if (typeof response !== "string") {
          setFileInfo(normalizeResponseData(response));
        }
      },
      onError: (error) => {
        console.error("Error during get data:", error);
      },
    },
  );

  const uploadFilesAndGetOnSuccess = useMutationData(
    queryKeys.uploadFiles,
    {
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
    },
    {
      onSuccess: () => {
        useSuccessToast(TOAST.success, t("common.files-upload-success"));
        getFileInformation.mutate(fileGroupNo);
      },
      onError: (error) => {
        console.error("Error during upload data:", error);
        ToastConstant(TOAST.error, t("common.files-upload-error"));
      },
    },
  );

  const uploadFiles = useMutationData(
    queryKeys.uploadFiles,
    {
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
    },
    {
      onSuccess: () => {
        useSuccessToast(TOAST.success, t("common.files-upload-success"));
      },
      onError: (error) => {
        console.error("Error during upload data:", error);
        ToastConstant(TOAST.error, t("common.files-upload-error"));
      },
    },
  );

  const uploadFilesWithCustomCallback = useMutationData(queryKeys.uploadFiles, {
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
  });

  return {
    uploadFilesWithCustomCallback,
    fileInfo,
    documentTotalData,
    getFileInformation,
    getFileInformationPagination,
    uploadFiles,
    uploadFilesAndGetOnSuccess,
  };
};
